import { useAtomAction, useAtomData } from '@lighthouse/shared'
import { useClickAway } from 'react-use'

import { clearSelectionAtom } from '@/atoms/page/action'
import { pageInternalStateAtomFamily } from '@/atoms/page/state'
import { AsideType } from '@/atoms/page/types'
import { useCurrentStackIdContext } from '@/contexts/PageContext'

type Configure = {
    ref: React.RefObject<HTMLElement | null>
    enabled?: boolean
}

/** 监听点击栅格外的事件 */
export const useClickAwayOutside = ({ ref, enabled }: Configure) => {
    const stackId = useCurrentStackIdContext()
    const { asideType, selectedNodes } = useAtomData(pageInternalStateAtomFamily(stackId))
    const { run: clearSelection } = useAtomAction(clearSelectionAtom)

    useClickAway(ref, e => {
        if (!enabled) {
            return
        }
        const { target } = e
        if (target instanceof Element) {
            const IGNORE_TYPE = 'data-ignore-click-away'
            const rootNodeID = 'root'

            if (e.composedPath().some(e => e instanceof Element && e.hasAttribute(IGNORE_TYPE))) {
                return
            }

            // // 点击右侧栏内容
            // if (document.querySelector(`.${RIGHT_ASIDE_CLASS}`)?.contains(target)) {
            //     return
            // }

            // 点击导航栏或底部导航栏且当前已选中导航栏
            const navbarEle = document.querySelector('#NAVBAR_HEADER')
            const tabBarEle = document.querySelector(`#TAB_BAR`)
            if ((navbarEle?.contains(target) || tabBarEle?.contains(target)) && asideType === AsideType.NAVBAR) {
                return
            }

            // 点击root外的节点，例如弹窗，忽略该点击事件
            if (!document.querySelector(`#${rootNodeID}`)?.contains(target)) {
                return
            }
        }

        if (asideType === AsideType.PAGE && (!selectedNodes || selectedNodes.length === 0)) {
            return
        }

        clearSelection(stackId)
    })
}
